import React, { useState } from "react";
import { Mail, LogIn } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo-pm.svg";

const ForgetPasswordPage = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = (e) => {
    e.preventDefault();

    // منطق التحقق المؤقت
    if (email) {
      // هنا يتم توجيه المستخدم لرسالة نجاح أو العودة للرئيسية
      console.log("تم إرسال رابط الاستعادة إلى:", email);
      alert("تم إرسال رابط استعادة كلمة المرور إلى بريدك الإلكتروني");
      navigate("/");
    } else {
      alert("يرجى إدخال البريد الإلكتروني");
    }
  };

  return (
    <div className="flex min-h-screen font-ibm bg-white" dir="rtl">
      {/* القسم الأيمن: النموذج */}
      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8 relative">
        <div className="max-w-md w-full">
          {/* الشعار */}
          <div className="flex flex-col items-center mb-10">
            <Link to="/" className="block">
              <img src={logo} alt="Logo" style={{ width: "70%" }} />
            </Link>
          </div>

          {/* العناوين */}
          <div className="text-right mb-8">
            <h2 className="text-3xl font-bold text-[#263238] mb-2">
              تغيير كلمة المرور
            </h2>
            <p className="text-gray-500 text-sm mb-1">
              أدخل بريدك الإلكتروني لاستعادة كلمة المرور الخاصة بك.
            </p>
            <p className="text-gray-500 text-sm">
              أو يمكنك تسجيل الدخول إلى حسابك من{" "}
              <Link to="/" className="text-blue-600 hover:underline font-bold">
                هنا
              </Link>
            </p>
          </div>

          {/* النموذج */}
          <form className="space-y-6" onSubmit={handleResetPassword}>
            {/* حقل البريد الإلكتروني */}
            <div className="relative group">
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" "
                className="block w-full p-4 pr-12 text-right bg-gray-50 border border-gray-100 rounded-xl focus:ring-2 focus:ring-[#263238] outline-none transition-all peer"
              />
              <label
                htmlFor="email"
                className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-12 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#263238] pointer-events-none"
              >
                البريد الإلكتروني
              </label>
              <Mail
                className="absolute top-1/2 right-4 -translate-y-1/2 text-gray-400"
                size={20}
              />
            </div>

            {/* زر الإرسال */}
            <button
              type="submit"
              className="w-full bg-[#546E7A] hover:bg-[#263238] text-white font-bold py-3.5 rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 mt-4 active:scale-[0.98]"
            >
              <LogIn size={20} className="rotate-180" />
              <span>إرسال رابط الاستعادة</span>
            </button>
          </form>
        </div>

        {/* الحقوق */}
        <div className="absolute bottom-6 text-[12px] text-gray-400 text-center w-full">
          © 2026 جميع الحقوق محفوظة للإدارة العامة للعمليات والتوقيع الإلكتروني
        </div>
      </div>

      {/* القسم الأيسر: الجمالي */}
      <div className="hidden lg:flex flex-col justify-center items-center w-1/2 bg-gradient-to-br from-[#607D8B] to-[#263238] p-12 text-white relative overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-white opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-black opacity-10 rounded-full blur-3xl"></div>

        <div className="relative z-10 text-center max-w-md">
          <h2 className="text-4xl font-extrabold mb-6 leading-tight">
            نظام العمليات والتوقيع الإلكتروني
          </h2>
          <p className="text-lg opacity-80 font-light leading-relaxed">
            لا تقلق، سنساعدك في استعادة الوصول إلى حسابك بأمان وسهولة.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordPage;
